import {
  setAllRatingTemplates,
  ratingTemplatesSelector,
} from '../reducers/ratingTemplatesReducer';
import { getRatingTemplates } from '../../services/apiService';

export function fetchRatingTemplates() {
  return async (dispatch, getState) => {
    const existingTemplates = ratingTemplatesSelector(getState());
    if (!existingTemplates.length) {
      try {
        const templates = await getRatingTemplates();
        dispatch(setAllRatingTemplates(templates));
      } catch (e) {
        console.error(e);
      }
    }
  };
}
